<div *ngIf="isLoading" class="loading">
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
</div>
<form action="" *ngIf="!isLoading">
  <mat-toolbar class="app-toolbar">
    <h2 *ngIf="careplan && !noCp" color="secondary" class="fontLarger align-middle">
      {{
        (patient.patient | getPatientFullName) +
          (patient.patient.pseudoname
            ? "
            (" +
              patient.patient.pseudoname +
              ")"
            : "")
      }}
    </h2>
    <span class="spacerBetween"></span>
    <h2 class="align-middle" *ngIf="!createNewCareplan && !noCp">
      {{ templateSelectedIndex ? initializedCareplanTemplates[templateSelectedIndex].description : careplan?.description }}
    </h2>
    <span class="spacerBetween"></span>
    <button
      mat-icon-button
      class="negative-margin align-middle color-button"
      matTooltipClass="helpTooltip"
      matTooltipPosition="left"
      #tooltip="matTooltip"
      matTooltip="{{ 'globalHelp.editCareplanHelp' | translate }}"
      aria-label="icon button with a ? icon"
      (click)="tooltip.toggle()"
    >
      <mat-icon>help_outline</mat-icon>
    </button>
  </mat-toolbar>

  <div class="content-panel">
    <!-- loading spinner -->
    <mat-spinner class="centerSpinner" *ngIf="!pageLoaded"></mat-spinner>
    <!-- Edit anonymous form patient (only birthdate and gender if not init) -->
    <app-edit-anonymous-patient *ngIf="includeBirthdateAndGenderForm" [patientUser]="patient"> </app-edit-anonymous-patient>
    <ng-container *ngIf="pageLoaded">
      <ng-container *ngIf="createNewCareplan">
        <div>
          <!-- careplan template selection -->
          <h2 color="secondary" *ngIf="initializedCareplanTemplates.length > 1 || departments.length > 1" class="fontLarger">
            {{
              isAllServices
                ? ("page.careplan.choosetemplate" | translate) + ("page.careplan.in" | translate)
                : ("page.careplan.choosetemplate" | translate)
            }}
            &nbsp;
          </h2>
          <!-- Department Selector (Services) -->
          <span *ngIf="isAllServices && registration" class="department-select">{{ selectedDepartment?.display }}</span>
          <mat-form-field *ngIf="isAllServices && !registration" floatLabel="never" class="department-select">
            <mat-select
              [compareWith]="compareReference"
              [placeholder]="'forms.services' | translate"
              [(value)]="selectedDepartment"
              (selectionChange)="updateDepartment($event)"
            >
              <mat-option *ngFor="let department of departments" [value]="department">
                {{ department.display }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="!noCp" id="careplansListContainer">
          <ng-container *ngFor="let template of initializedCareplanTemplates; let i = index">
            <button
              class="btn-template"
              mat-stroked-button
              color="primary"
              *ngIf="templateSelectedIndex !== i"
              (click)="onTemplateSelected(i)"
            >
              {{ template.description }}
            </button>
            <button
              class="btn-template"
              mat-raised-button
              color="primary"
              *ngIf="templateSelectedIndex === i"
              (click)="onTemplateSelected(i)"
            >
              {{ template.description }}
            </button>
          </ng-container>
        </div>
      </ng-container>

      <p *ngIf="readOnlyWithoutDrugs" class="read-only-message">{{ "page.careplan.readOnlyWithoutDrugs" | translate }}</p>
      <!-- Careplan header: status, dates, reference -->
      <table class="w-100" *ngIf="careplan">
        <tr>
          <td>
            <!-- careplan status -->
            <mat-form-field class="w-100 font-12" style="padding-bottom: 4px">
              <mat-label>{{ "status.label" | translate }}</mat-label>
              <mat-select [(ngModel)]="careplan.status" name="status" [disabled]="!authorizedToEdit">
                <mat-option value="draft">{{ "status.draft" | translate }}</mat-option>
                <mat-option value="inactive">{{ "status.inactive" | translate }}</mat-option>
                <mat-option value="active">{{ "status.active" | translate }}</mat-option>
                <mat-option value="archive">{{ "status.archive" | translate }}</mat-option>
                <mat-option value="error">{{ "status.error" | translate }}</mat-option>
              </mat-select>
            </mat-form-field>
          </td>
          <td>
            <!-- careplan start date -->
            <mat-form-field class="w-100 font-12">
              <mat-label>{{ "schedule.dateFrom" | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="careplan.period.start"
                [matDatepicker]="dateFromPicker"
                name="periodStart"
                required
                [disabled]="!authorizedToEdit"
                [max]="noEndDate ? null : careplan.period.end"
                (change)="onPeriodStartDateChanged(careplan.period.start, careplan.period.end)"
                (click)="dateFromPicker.open()"
              />
              <mat-datepicker-toggle matSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
              <mat-datepicker #dateFromPicker></mat-datepicker>
            </mat-form-field>
          </td>
          <td *ngIf="!noEndDate">
            <!-- careplan end date -->
            <mat-form-field class="w-100 font-12">
              <mat-label>{{ "schedule.dateTo" | translate }}</mat-label>
              <input
                matInput
                [(ngModel)]="careplan.period.end"
                [matDatepicker]="dateToPicker"
                name="periodEnd"
                required
                [disabled]="!authorizedToEdit"
                [min]="careplan.period.start"
                (change)="onPeriodEndDateChanged(careplan.period.start, careplan.period.end)"
                (click)="dateToPicker.open()"
              />
              <mat-datepicker-toggle matSuffix [for]="dateToPicker"></mat-datepicker-toggle>
              <mat-datepicker #dateToPicker></mat-datepicker>
            </mat-form-field>
          </td>
          <td>
            <mat-slide-toggle
              [(ngModel)]="noEndDate"
              name="noEndDate"
              class="ml-15"
              [disabled]="!authorizedToEdit"
              (change)="onEndlessCareplan()"
            >
              {{ "mydrugs.noEndDate" | translate }}
            </mat-slide-toggle>
          </td>
          <td>
            <!-- careplan reference -->
            <mat-form-field class="w-100 font-12">
              <mat-icon matSuffix class="fa fa-key"></mat-icon>
              <mat-label>{{ "knowledgebase.snomedRef" | translate }}</mat-label>
              <input
                disabled="true"
                matInput
                placeholder="{{ 'page.patient.reference' | translate }}"
                [(ngModel)]="careplan.category[0].coding[0].code"
                name="careplanRef"
              />
            </mat-form-field>
          </td>
        </tr>
        <!-- Display each address if exists -->
        <tr *ngIf="careplan?.addresses && careplan?.addresses?.length">
          <td>
            <span style="margin-left: 20%">{{ "careplan.type" | translate }}</span>
            <ul [ngClass]="{ 'has-error': anyAddressActive === false }">
              <li *ngFor="let addresse of careplan?.addresses">
                <mat-checkbox
                  [checked]="addresse.status === 'active'"
                  (change)="onCheckedAddresses(addresse)"
                  [disabled]="!authorizedToEdit"
                >
                  {{ addresse.display }}
                </mat-checkbox>
              </li>
            </ul>
          </td>
        </tr>
      </table>

      <!-- display each activity -->
      <app-careplan-activity
        *ngFor="let activity of careplan?.activity; let i = index"
        [activity]="activity"
        [activityIndex]="i"
        [careplan]="careplan"
        [noEndDate]="noEndDate"
        [authorizedToEdit]="authorizedToEdit"
        [createNewCareplan]="createNewCareplan"
        [protocols]="protocols"
        [routes]="routes"
        [administrations]="administrations"
        [diluents]="diluents"
        [administrators]="administrators"
        [drugCycles]="drugCycles"
        [drugStepwises]="drugStepwises"
        [timingCodes]="timingCodes"
        [quantities]="quantities"
        [availablePeriodUnits]="availablePeriodUnits"
        (activityChecked)="recomputeStartEndDate()"
        (startDateChanged)="onStartDateChanged()"
        (endDateChanged)="onEndDateChanged()"
        (periodChanged)="periodChange($event.activityIndex, $event.actionIndex)"
        (communicationShown)="showCommunication($event)"
        (useForCareplanEndDate)="careplan.period.end = $event"
        (drugCycleChanged)="cycleChanged($event)"
        (stepwiseDrugChanged)="stepwiseDrugChanged($event)"
      >
      </app-careplan-activity>
    </ng-container>
    <ui-alert *ngIf="noCp" [options]="{ type: 'error', showIcon: true }">
      {{ "careplan.noCp" | translate }}
    </ui-alert>
  </div>
  <div class="ui-dialog-actions">
    <button mat-raised-button color="primary" type="submit" (click)="save()" style="float: right" [disabled]="isLoading">
      {{
        (patientRegistrationService.isLastStep || !createNewCareplan
          ? authorizedToEdit
            ? "model.patient.finish"
            : "btn.close"
          : "globalHelp.nextSlide"
        ) | translate
      }}
    </button>
  </div>
</form>
